/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";
import colors from "assets/theme-dark/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { borderWidth } = borders;
const { light ,primary,background,text,error} = colors;

const tableCell = {
  styleOverrides: {
    root: {
      color:`${text.main}`,
      boxShadow: 2,
      fontSize:'small',
      fontWeight:'normal',
      // textAlign: 'center',
      background:`${background.sidenav} !important`,
      // padding: `${pxToRem(6)} ${pxToRem(8)}`,
      border: `${borderWidth[1]} solid ${light.main}`,
      '&:hover': {
        color: primary.light,
        cursor: 'pointer',
      },
      '&:focus': {
        outline: 'none',
        border: `1px solid ${primary.light}`,
      },

      '&[data-pinned="true"]': {
        background: `${background.default} !important`, // 自定义背景色
        fontWeight: 'bold', // 加粗字体
        opacity:1,
      },

      "&.error": {
        border: `2px solid ${error.main} !important`, // 红色边框
        backgroundColor: `${light.main} !important`, // 可选：修改背景颜色
      },

    },
  },
};

export default tableCell;
